customElements.get("vanilla-slider") || customElements.define("vanilla-slider", class extends HTMLElement {
  constructor() {
    super(), this.slider = this.querySelector("[data-slider]"), this.slides = this.querySelectorAll("[data-slide]"), 
    this.prev = this.querySelectorAll("[data-prev]"), this.next = this.querySelectorAll("[data-next]"), 
    this.nav = this.querySelectorAll("[data-nav]"), this.animate = this.hasAttribute("data-animate"), 
    this.enableDrag = this.hasAttribute("data-enable-drag") && "false" !== this.dataset.enableDrag, 
    this.autoplay = Number(1e3 * this.dataset.autoplay || 0), this.autoplay && (this.autoplay, 
    parseInt(getComputedStyle(document.documentElement).getPropertyValue("--duration"))), 
    this.autoplayIndex = 0, this.interval, this.isDragging = !1, this.startX = 0, this.dragStartScrollLeft = 0, 
    this.originalScrollSnapType = null, this.originalScrollBehavior = null, this.dragged = !1, 
    this.velocity = 0, this.lastMoveTime = 0, this.lastMoveX = 0, this.boundHandleDragMove = this.handleDragMove.bind(this), 
    this.boundHandleDragEnd = this.handleDragEnd.bind(this);
  }
  connectedCallback() {
    if (!this.slider) return !1;
    const t = () => {
      0 !== this.slider.scrollLeft && (this.slider.scrollLeft = 0);
    };
    t(), setTimeout(t, 100), window.addEventListener("load", t), this.addEventListeners(), 
    window.addEventListener("load", () => this.update()), document.addEventListener("DOMContentReady", () => this.update()), 
    this.enableDrag && (this.originalScrollSnapType = getComputedStyle(this.slider).scrollSnapType, 
    this.originalScrollBehavior = getComputedStyle(this.slider).scrollBehavior, this.slider.style.cursor = "grab"), 
    this.autoplay && (this.interval = setInterval(() => {
      this.autoplayIndex = this.autoplayIndex + 1 > this.slides.length - 1 ? 0 : this.autoplayIndex + 1, 
      this.goTo(this.autoplayIndex);
    }, this.autoplay));
  }
  getSlideWidth() {
    const t = [ ...this.slides ].find(t => t.offsetWidth > 0);
    if (!t) return this.slider.offsetWidth;
    const e = parseInt(getComputedStyle(this.slider).getPropertyValue("gap").split(" ")[0]) || 0;
    return t.offsetWidth + e;
  }
  scroll(t, e = !1) {
    e && (e.preventDefault(), e.stopPropagation());
    const s = this.getSlideWidth(), i = "left" === t ? -s : s;
    this.slider.scrollBy({
      left: i,
      behavior: "smooth"
    });
  }
  goTo(t, e = "smooth") {
    this.slider.scrollTo({
      left: this.getSlideWidth() * parseInt(t),
      behavior: e
    });
  }
  hideArrow(t) {
    t.disabled = !0, t.ariaDisabled = !0;
  }
  showArrow(t) {
    t.disabled = !1, t.ariaDisabled = !1;
  }
  updateArrows() {
    const t = this.slider.scrollLeft, e = this.slider.offsetWidth, s = this.slider.scrollWidth;
    parseInt(getComputedStyle(document.documentElement).getPropertyValue("--spacing-offset")), 
    this.prev.forEach(e => t > 1 ? this.showArrow(e) : this.hideArrow(e)), this.next.forEach(i => t + e < s - 1 ? this.showArrow(i) : this.hideArrow(i));
  }
  updateNav() {
    const t = this.getIndex();
    this.nav.forEach(e => {
      e.querySelectorAll("button").forEach((e, s) => {
        if (e.ariaCurrent = s === t ? "true" : "false", this.animate) {
          const i = e.querySelector("span");
          if (!i) return;
          i.classList.remove("w-full", "duration-[var(--delay)]", "transition-all"), s === t ? i.classList.add("w-full", "duration-[var(--delay)]", "transition-all") : i.classList.add("w-0");
        }
      });
    });
  }
  getIndex() {
    const t = this.getSlideWidth();
    return 0 === t ? 0 : Math.round(this.slider.scrollLeft / t);
  }
  update() {
    this.updateArrows(), setTimeout(() => this.updateNav(), 50);
  }
  smoothScrollTo(t, e) {
    return new Promise(s => {
      const i = this.slider.scrollLeft, r = t - i;
      let a = null;
      const l = o => {
        null === a && (a = o);
        const h = o - a, n = Math.min(h / e, 1), d = (c = n) < .5 ? 4 * c * c * c : (c - 1) * (2 * c - 2) * (2 * c - 2) + 1;
        var c;
        this.slider.scrollLeft = i + r * d, h < e ? requestAnimationFrame(l) : (this.slider.scrollLeft = t, 
        s());
      };
      requestAnimationFrame(l);
    });
  }
  getDragTargetIndex() {
    const t = this.getSlideWidth();
    if (0 === t) return 0;
    const e = this.slider.scrollLeft, s = e - .5 * this.velocity;
    let i = Math.round(s / t);
    Math.abs(this.velocity) < 200 && (i = Math.round(e / t));
    const r = this.slides.length;
    return Math.max(0, Math.min(i, r - 1));
  }
  handleDragStart(t) {
    this.enableDrag && (this.dragged = !1, t.preventDefault(), this.isDragging = !0, 
    this.slider.style.cursor = "grabbing", this.slider.classList.add("dragging"), this.slider.style.scrollSnapType = "none", 
    this.slider.style.scrollBehavior = "auto", this.slider.style.userSelect = "none", 
    this.startX = t.pageX - this.slider.offsetLeft, this.dragStartScrollLeft = this.slider.scrollLeft, 
    this.velocity = 0, this.lastMoveTime = performance.now(), this.lastMoveX = t.pageX, 
    this.autoplay && clearInterval(this.interval), document.addEventListener("mousemove", this.boundHandleDragMove, {
      passive: !1
    }), document.addEventListener("mouseup", this.boundHandleDragEnd, {
      once: !0
    }));
  }
  handleDragMove(t) {
    if (!this.isDragging) return;
    this.dragged = !0, t.preventDefault();
    const e = 2 * (t.pageX - this.slider.offsetLeft - this.startX);
    this.slider.scrollLeft = this.dragStartScrollLeft - e;
    const s = performance.now(), i = s - this.lastMoveTime, r = t.pageX - this.lastMoveX;
    if (i > 16) {
      const e = 1e3 * r / (1 + i);
      this.velocity = .8 * e + .2 * this.velocity, this.lastMoveTime = s, this.lastMoveX = t.pageX;
    }
  }
  async handleDragEnd() {
    if (!this.isDragging) return;
    this.isDragging = !1, this.slider.classList.remove("dragging"), this.slider.style.cursor = "grab", 
    this.slider.style.userSelect = "";
    const t = this.getSlideWidth(), e = this.getDragTargetIndex() * t;
    await this.smoothScrollTo(e, 400), this.slider.style.scrollSnapType = this.originalScrollSnapType, 
    this.slider.style.scrollBehavior = this.originalScrollBehavior, document.removeEventListener("mousemove", this.boundHandleDragMove), 
    this.update(), this.autoplay && (this.interval = setInterval(() => {
      this.autoplayIndex = this.autoplayIndex + 1 > this.slides.length - 1 ? 0 : this.autoplayIndex + 1, 
      this.goTo(this.autoplayIndex);
    }, this.autoplay));
  }
  addEventListeners() {
    this.prev.forEach(t => t.addEventListener("click", t => this.scroll("left", t))), 
    this.next.forEach(t => t.addEventListener("click", t => this.scroll("right", t))), 
    this.nav.forEach(t => t.querySelectorAll("button").forEach((t, e) => t.addEventListener("click", () => this.goTo(e)))), 
    this.autoplay && [ "wheel", "touchmove", "click" ].forEach(t => {
      this.addEventListener("click", () => clearInterval(this.interval), {
        once: !0
      });
    }), this.enableDrag && (this.slider.addEventListener("mousedown", t => this.handleDragStart(t)), 
    this.slider.addEventListener("click", t => {
      this.dragged && (t.preventDefault(), t.stopPropagation());
    }, {
      capture: !0
    }));
    const t = new IntersectionObserver(t => {
      t.forEach(t => t.target.ariaCurrent = t.isIntersecting);
    }, {
      root: this.slider,
      threshold: .8
    });
    this.slides.forEach(e => t.observe(e)), new MutationObserver(() => {
      this.slides = this.querySelectorAll("[data-slide]"), t.disconnect(), this.slides.forEach(e => t.observe(e)), 
      this.update();
    }).observe(this.slider, {
      childList: !0
    }), [ "scroll", "scrollend" ].forEach(t => this.slider.addEventListener(t, () => {
      this.isDragging || this.update();
    }, {
      passive: !0
    }));
  }
});